import Image from "../../assets/img/hero/hero.jpg";
import Search from "../Search/Search";

const Banner = () => {
  return (
    <section className="relative w-full h-screen flex flex-col items-center justify-center">
      {/* Imagen de fondo */}
      <div className="absolute top-0 left-0 w-full h-full">
        <img src={Image} alt="" className="w-full h-full object-cover" />
        <div className="absolute top-0 left-0 w-full h-full bg-black/20"></div>
      </div>

      {/* Contenido */}
      <div className="relative z-10 flex flex-col items-center text-center text-white px-4">
        <h1 className="text-4xl lg:text-6xl font-bold leading-tight mb-6">
          Tu nuevo comienzo empieza acá.
        </h1>
      </div>
      {/* Barra de búsqueda */}
      <div className="w-full max mt-10 px-2">
        <Search />
      </div>
    </section>
  );
};

export default Banner;
